import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { ROW } from '../../virtualization/types/observerTypes';
import { useObserveTableElementRef } from '../../virtualization/hooks/useObserveTableElementRef';
import Cell from './Cell';
import SelectRowCheckboxCell from '../../selection/components/SelectRowCheckboxCell';

const Row = ({
  rowId,
  rowIndex,
  row,
  columns,
  selectable,
  RowComponent,
  numberOfFrozenColumns = 0
}) => {
  const handleObserveRef = useObserveTableElementRef();
  return /*#__PURE__*/_jsxs(RowComponent, {
    row: row,
    trRef: handleObserveRef,
    requiredRowProps: {
      'data-test-id': `row-${rowId}`,
      'data-observer-type': ROW,
      'data-observer-id': rowIndex
    },
    children: [selectable && /*#__PURE__*/_jsx(SelectRowCheckboxCell, {
      numberOfFrozenColumns: numberOfFrozenColumns,
      rowId: rowId
    }), columns.map((column, columnIndex) => {
      const {
        CellComponent,
        columnNamespace,
        columnName
      } = column;
      return /*#__PURE__*/_jsx(Cell, {
        columnIndex: columnIndex,
        rowIndex: rowIndex,
        columnNamespace: columnNamespace,
        columnName: columnName,
        CellComponent: CellComponent,
        rowId: rowId,
        row: row,
        numberOfFrozenColumns: numberOfFrozenColumns
      }, `${columnNamespace}-${columnName}-${rowId}`);
    })]
  });
};

export default /*#__PURE__*/memo(Row);